import { useEvent } from '@/store';
import { useGetPaymentMethodsQuery } from '@/store/checkout/checkout.api';

const DEFAULT_PROP = 'Gateway::Banwire';
const DEFAULT_PAYMENT_GATEWAY = 'OPEN_PAY';

export default function usePaymentGateway() {
  const {
    event: {
      event: { id },
    },
  } = useEvent();

  const { data: payment_methods } = useGetPaymentMethodsQuery(id || 0);

  const getPaymentGateway = async () => {
    try {
      const payment_gateway = payment_methods?.find(
        (payment_method) => payment_method.type === DEFAULT_PROP,
      );
      return payment_gateway.payment_gateway || DEFAULT_PAYMENT_GATEWAY;
    } catch {
      return false;
    }
  };

  return {
    getPaymentGateway,
  };
}
